/**
* Helper method to get the styles for Icon component
* @param {Object} contextStyles - Context styles for Icon Component
*/const getStyles=function(){let contextStyles=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return{popper:{...contextStyles.container},tooltip:{...contextStyles.toolTipText}};};export default getStyles;